import { classNames } from "primereact/utils";

const tooltip = {
  root: ({ context }) => {
      return {
          className: classNames('absolute shadow-md', {
              'py-0 px-1': context.right || context.left || (!context.right && !context.left && !context.top && !context.bottom),
              'py-1 px-0': context.top || context.bottom
          })
      };
  },
  arrow: ({ context }) => ({
      className: classNames('absolute w-0 h-0 border-transparent border-solid', {
          '-mt-2.5 -ml-2 border-y-[0.75rem] border-r-[1rem] border-l-0 border-r-allstate-blue': context.right,
          '-mt-2.5 -mr-2 border-y-[0.75rem] border-l-[1rem] border-r-0 border-l-allstate-blue': context.left,
          '-ml-2.5 -mb-2 border-x-[0.75rem] border-t-[1rem] border-b-0 border-t-allstate-blue': context.top,
          '-ml-2.5 -mt-2 border-x-[0.75rem] border-b-[1rem] border-t-0 border-b-allstate-blue': context.bottom
      })
  }),
  text: {
      className: 'p-2.5 bg-allstate-blue text-sm text-white whitespace-pre-line break-words'
  }
};

export default tooltip;
        